import { useEffect } from "react";
import { getNetworkError } from "./functions";

export const useNetworkError = (setError) => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleOffline = () => {
      document.getElementById("btn-payment-modal-close")?.click();
      const { title, message, retryFunction } = getNetworkError();
      setError({
        hasError: true,
        title,
        message,
        canRetry: true,
        // retryText: "Retry",
        retryFunction,
      });
    };

    if (!navigator.onLine) handleOffline();

    window.addEventListener("offline", handleOffline);
    return () => window.removeEventListener("offline", handleOffline);
  }, [setError]);
};
